<p>purchaseorderlinedetailassign works!</p>
